(function () {
  "use strict";

  var DURATION = 200;
  var EASING = "cubic-bezier(0.4, 0, 0.2, 1)";

  function initRoot(root) {
    if (!root || root.dataset.npFaqInit === "true") return;
    root.dataset.npFaqInit = "true";

    var items = root.querySelectorAll("[data-np-faq-item]");

    /* Every item's controller, so opening one can close the rest. */
    var panels = [];

    Array.prototype.forEach.call(items, function (item) {
      var trigger = item.querySelector("[data-np-faq-trigger]");
      var content = item.querySelector("[data-np-faq-content]");
      if (!trigger || !content) return;

      /* Bumped on every open/close. A transition callback only settles the
         animation it was started for, so a run interrupted part-way (a
         sibling closing while it is still opening) cannot settle later and
         strand the panel at the wrong height. */
      var run = 0;

      function isOpen() {
        return item.getAttribute("data-state") === "open";
      }

      /* Fires the callback at transitionend, or on a timer if the
         transition never runs (zero height delta, reduced motion). */
      function afterTransition(token, fn) {
        function onEnd(e) {
          if (e && e.propertyName !== "height") return;
          if (token !== run) {
            content.removeEventListener("transitionend", onEnd);
            return;
          }
          content.removeEventListener("transitionend", onEnd);
          fn();
        }
        content.addEventListener("transitionend", onEnd);
        setTimeout(function () {
          if (token === run) onEnd();
        }, DURATION + 60);
      }

      function open() {
        if (isOpen()) return;
        var token = ++run;

        item.setAttribute("data-state", "open");
        content.setAttribute("data-state", "open");
        trigger.setAttribute("aria-expanded", "true");

        content.style.transition = "";
        content.style.height = "0px";
        /* force layout so the transition has a start value */
        void content.offsetHeight;
        content.style.transition = "height " + DURATION + "ms " + EASING;
        content.style.height = content.scrollHeight + "px";

        afterTransition(token, function () {
          content.style.transition = "";
          content.style.height = "auto";
        });
      }

      function close() {
        if (!isOpen()) return;
        var token = ++run;

        trigger.setAttribute("aria-expanded", "false");

        /* from the current measured height, not auto — auto is not animatable */
        content.style.transition = "";
        content.style.height = content.scrollHeight + "px";
        void content.offsetHeight;
        content.style.transition = "height " + DURATION + "ms " + EASING;
        content.style.height = "0px";

        afterTransition(token, function () {
          content.style.transition = "";
          item.setAttribute("data-state", "closed");
          content.setAttribute("data-state", "closed");
        });
      }

      var panel = { open: open, close: close, isOpen: isOpen };
      panels.push(panel);

      trigger.addEventListener("click", function () {
        if (panel.isOpen()) {
          close();
          return;
        }
        /* one at a time — collapse whichever sibling is open */
        panels.forEach(function (other) {
          if (other !== panel) other.close();
        });
        open();
      });

      /* Items rendered open start at their natural height. */
      if (isOpen()) content.style.height = "auto";
    });

    /* Guard against markup that opens more than one item. */
    var open = panels.filter(function (p) {
      return p.isOpen();
    });
    open.slice(1).forEach(function (p) {
      p.close();
    });
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll("[data-np-faq]");
    Array.prototype.forEach.call(roots, initRoot);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", function (e) {
    initAll(e.target);
  });
})();
